export default __webpack_public_path__ + "static/media/undraw_not_found.4e6fde16.svg";